import React, { FC, useRef } from 'react';
import { Dialog, DialogTitle, Fade, Grid, IconButton, LinearProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/system';
import CargoFeeManagementCommand from '../../../../services/command/cargoFeeManagement/CargoFeeManagementCommand.services';
import Swal from 'sweetalert2';
import { readExcelFile } from '../../../../utils/excelFileHelper';
import { CFM, cfmCls } from '../../cargoFeeManagement.classes';

export const SCUICargoFeeUploadComponent: FC<{
    open: boolean;
    handleModalClose: any;
    onClose: any;
    orderNo: any;
    setOrderNo: any;
    listele?: any;
    text?: any;
    loadingExcel?: any;
    setLoadingExcel?: any;
}> = ({ open, onClose, handleModalClose, loadingExcel, setLoadingExcel }) => {
    const { t } = useTranslation();
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
        setLoadingExcel(true);
        const file = event.target.files?.[0];
        if (!file) {
            console.error('No file selected.');
            return;
        }

        try {
            const parsedData = await readExcelFile(file);
            if (!parsedData) {
                console.error('Failed to parse Excel data.');
                return;
            }

            const requestData = prepareDataForAPI(parsedData);
            if (!requestData) {
                console.error('Failed to prepare data for API.');
                return;
            }

            try {
                await CargoFeeManagementCommand.AddCargoFeeFromExcel(requestData).then(() => {
                    setLoadingExcel(false);
                    handleModalClose();
                    Swal.fire(t('general.added'), ' ', 'success');
                });
            } catch (error) {
                console.error('API request error:', error);
            }
        } catch (error) {
            console.error('File reading error:', error);
        }
    };

    const prepareDataForAPI = (data: any[][]): any[] | null => {
        const formattedData = data.slice(1).map((item: any) => {
            return {
                shippingCompanyId: Number(item[0]),
                distanceTypeId: Number(item[2]),
                departureLocationTypeId: Number(item[4]),
                desi: Number(item[6]),
                price: Number(item[7]),
                validStartDate: new Date(item[8]),
                validEndDate: new Date(item[9]),
                isActive: item[10],
            };
        });
        return formattedData.filter((x) => x.distanceTypeId);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth={'xs'} fullWidth className={CFM.uploadDialog}>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', marginBottom: 3 }}>
                {t('cargoFeeManagement.excelUpload')}
                <IconButton sx={{ ml: 'auto' }}></IconButton>
            </DialogTitle>
            <Box>
                <Fade in={loadingExcel} unmountOnExit>
                    <LinearProgress />
                </Fade>
            </Box>
            <Grid
                container
                sx={{
                    flexDirection: 'column',
                    justifyContent: 'center',
                    display: 'flex',
                    height: '200px',
                }}
            >
                <input
                    type="file"
                    style={{ display: 'none' }}
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    className={cfmCls(CFM.input, CFM.inputFile, CFM.uploadFileInput)}
                />
                <button
                    type="button"
                    onClick={handleButtonClick}
                    style={{
                        border: '0px solid',
                        borderRadius: '1rem',
                        backgroundColor: 'transparent',
                        height: '230px',
                    }}
                    className={cfmCls(CFM.input, CFM.inputButton, CFM.uploadTrigger)}
                >
                    {t('cargoFeeManagement.excelUpload')}
                </button>
            </Grid>
        </Dialog>
    );
};
